import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { IVariableTypeApi } from "./base";
import { KeyValue } from "../models/common";

const baseRoute: string = "variabletype";

export class VariableTypeApi extends IVariableTypeApi {
	getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`);
	}
}
